module.exports = __webpack_public_path__ + "img/project_4.91fefeb3.jpg";